module.exports = __webpack_public_path__ + "static/media/table1.59397986.png";